<template>
  <div>
    <el-tabs
        v-model="show"
        @tab-click="changeConcernedTab"
    >
      <el-tab-pane
          label="关注列表"
          name="TABLE"
      >
        <concerned-table
            ref="concerned-table"
            @edit="showForm"
        ></concerned-table>
      </el-tab-pane>
      <el-tab-pane
          label="新增关注"
          name="FORM"
      >
        <concerned-form
            :model="editObj"
            @saved="showTable"
            @back="showTable"
        ></concerned-form>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import ConcernedForm from '@/components/concerned/ConcernedForm.vue'
import ConcernedTable from '@/components/concerned/ConcernedTable.vue'
import ConcernedInfo from '@/models/ConcernedInfo'

export default {
  components: {ConcernedTable, ConcernedForm},
  data() {
    return {
      show: 'TABLE',
      editObj: new ConcernedInfo()
    }
  },
  methods: {
    refreshTable() {
      this.$refs['concerned-table'].fetchInfos(0)
    },
    changeConcernedTab(tab) {
      switch (tab.name) {
        case 'TABLE':
        case 'FORM':
          this.editObj = new ConcernedInfo();
          if(!this.editObj.id) {
            this.editObj.receiveStart = "08:00"
            this.editObj.receiveEnd = "22:00"
          }
          break;
        default:
      }
    },
    showTable() {
      this.editObj = new ConcernedInfo()
      this.show = 'TABLE'
      this.refreshTable()
    },
    showForm(item) {
      this.editObj = new ConcernedInfo(item)
      if(!this.editObj.id) {
        this.editObj.receiveStart = "08:00"
        this.editObj.receiveEnd = "22:00"
      }
      this.show = 'FORM'
    }
  }
}
</script>
<style scoped>
</style>
